import { TRANSITION_BUTTON, TRANSITION_COLLAPSE } from '@/components/ui/motion.ts';

export const pillStyles = (isSelected: boolean, isWarning = false) => ({
	type: 'button' as const,
	h: 'auto',
	py: '10px',
	px: '20px',
	fontSize: '14px',
	fontWeight: 500,
	borderRadius: 'full',
	border: 'none',
	bg: isSelected ? (isWarning ? 'red.600' : 'primary') : 'white',
	color: isSelected ? 'white' : 'primary/70',
	cursor: 'pointer',
	boxShadow: isSelected ? 'none' : 'xs',
	_hover: isSelected
		? {}
		: {
				boxShadow: 'sm',
			},
	transition: TRANSITION_BUTTON,
});

export const datePickerPopupStyles = {
	borderRadius: '2xl',
	css: {
		'& [data-scope="date-picker"][data-part="table-cell-trigger"]': {
			borderRadius: 'xl',
		},
		'& [data-scope="date-picker"][data-part="prev-trigger"]': {
			borderRadius: 'full',
		},
		'& [data-scope="date-picker"][data-part="next-trigger"]': {
			borderRadius: 'full',
		},
		'& [data-scope="date-picker"][data-part="view-trigger"]': {
			borderRadius: 'full',
		},
		'& [data-scope="date-picker"][data-part="table-cell-trigger"][data-selected]': {
			background: 'var(--chakra-colors-brand-solid)',
			color: 'var(--chakra-colors-brand-contrast)',
		},
		'& [data-scope="date-picker"][data-part="table-cell-trigger"][data-selected]:hover': {
			background: 'var(--chakra-colors-brand-solid)',
			color: 'var(--chakra-colors-brand-contrast)',
		},
	},
} as const;

export const revealStyles = (isOpen: boolean) => ({
	display: 'grid' as const,
	css: {
		gridTemplateRows: isOpen ? '1fr' : '0fr',
		transition: TRANSITION_COLLAPSE,
		willChange: 'grid-template-rows',
	},
	margin: 0,
});

export const detailRevealStyles = revealStyles;
